import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import type { ActivityInsightNarrative } from '../types/usage-insights.types';

interface UsageInsightsNarrativeSectionProps {
  narrative: ActivityInsightNarrative;
}

export function UsageInsightsNarrativeSection({ narrative }: UsageInsightsNarrativeSectionProps) {
  return (
    <section className="rounded-xl border border-[#EDEEF2] bg-white p-5">
      <h2 className={portalDs.sectionTitle}>Narrative</h2>
      <p className="mt-3 text-sm leading-6 text-[#0D0F1A]">{narrative.summary}</p>

      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <FindingGroup
          title="Going well"
          findings={narrative.going_well}
          tone="positive"
        />
        <FindingGroup
          title="Needs attention"
          findings={narrative.needs_attention}
          tone="attention"
        />
      </div>
    </section>
  );
}

function FindingGroup({
  title,
  findings,
  tone,
}: {
  title: string;
  findings: ActivityInsightNarrative['going_well'];
  tone: 'positive' | 'attention';
}) {
  const accentClass = tone === 'positive'
    ? 'border-[#A7F3D0] bg-[#ECFDF5]'
    : 'border-[#FECACA] bg-[#FEF2F2]';

  return (
    <div>
      <h3 className="text-sm font-semibold text-[#0D0F1A]">{title}</h3>
      {findings.length === 0 ? (
        <p className={cn(portalDs.caption, 'mt-2')}>No findings.</p>
      ) : (
        <ul className="mt-3 space-y-3">
          {findings.map((finding) => (
            <li
              key={`${title}-${finding.headline}`}
              className={cn('rounded-lg border p-4', accentClass)}
            >
              <p className="text-sm font-semibold text-[#0D0F1A]">{finding.headline}</p>
              <p className="mt-1 text-sm text-[#5E6278]">{finding.detail}</p>
              <p className="mt-3 text-sm text-[#0D0F1A]">
                <span className="font-semibold">Recommendation:</span>
                {' '}
                {finding.recommendation}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
